module.exports = __webpack_public_path__ + "static/media/recruit_480_default0.4d4ec9eb.png";